import { render, staticRenderFns } from "./Temp.vue?vue&type=template&id=4cc7f10c&scoped=true"
import script from "./Temp.vue?vue&type=script&lang=js"
export * from "./Temp.vue?vue&type=script&lang=js"
import style0 from "./Temp.vue?vue&type=style&index=0&id=4cc7f10c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc7f10c",
  null
  
)

export default component.exports